import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, DownloadIcon, SmartphoneIcon, InfinityIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="w-full py-10 md:py-12 px-6 bg-white" data-id="element-66">
      <div className="max-w-2xl mx-auto" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="bg-gradient-to-br from-cream to-amber-50/30 rounded-3xl p-6 md:p-10 shadow-warm-xl border border-orange/10 text-center" data-id="element-68">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-brown-dark mb-6" data-id="element-69">
            🎯 Precio Final
          </h2>

          {/* Price Display */}
          <div className="mb-6" data-id="element-70">
            <p className="text-xl text-brown-muted line-through mb-1" data-id="element-71">
              $30.000 ARS
            </p>
            <motion.div initial={{
            scale: 0.9
          }} whileInView={{
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.2
          }} className="inline-block px-8 py-4 bg-orange rounded-2xl animate-pulse-glow" data-id="element-72">
              <span className="font-heading text-4xl md:text-5xl font-bold text-white" data-id="element-73">
                $14.999 ARS
              </span>
            </motion.div>
          </div>

          {/* Details */}
          <div className="space-y-2 mb-8" data-id="element-74">
            <div className="flex items-center justify-center gap-3 text-brown-light" data-id="element-75">
              <DownloadIcon className="w-5 h-5 text-orange" data-id="element-76" />
              <span className="font-body" data-id="element-77">
                Formato: PDF digital (descarga inmediata)
              </span>
            </div>
            <div className="flex items-center justify-center gap-3 text-brown-light" data-id="element-78">
              <SmartphoneIcon className="w-5 h-5 text-orange" data-id="element-79" />
              <span className="font-body" data-id="element-80">
                Dispositivos: Celular, tablet, computadora
              </span>
            </div>
            <div className="flex items-center justify-center gap-3 text-brown-light" data-id="element-81">
              <InfinityIcon className="w-5 h-5 text-orange" data-id="element-82" />
              <span className="font-body" data-id="element-83">Acceso: De por vida</span>
            </div>
          </div>

          {/* CTA Button */}
          <motion.a href="https://www.mamaexpres.com/cart/53191481131281:1" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center gap-3 px-10 py-5 bg-orange text-white font-bold text-xl rounded-full shadow-warm-lg hover:bg-orange-dark hover:shadow-warm-xl transition-all duration-300" data-id="element-84">
            ¡Quiero mis Recetas Rescate!
            <ArrowRightIcon className="w-6 h-6" data-id="element-85" />
          </motion.a>

          <p className="mt-4 text-sm text-brown-muted" data-id="element-86">🔒 Pago 100% seguro</p>
        </motion.div>
      </div>
    </section>;
}